import React, { useEffect, useState, useRef } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import filter from "../../Assets/svg/filter.svg";
import lar from "../../Assets/svg/lar.svg";
import backarrow from "../../Assets/svg/backarrow.svg";
import reddelete from "../../Assets/svg/reddelete.svg";
import close from "../../Assets/svg/close1.svg";
import { apiCall } from "../../services/api-service.js";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import { useNavigate, useLocation } from "react-router-dom";

const getApiEndpoint = (url) => {
  const isAbsolute = /^https?:\/\//i.test(url);
  const baseUrl = process.env.REACT_APP_API_URL || "";
  return isAbsolute ? url : baseUrl + url;
};
// Helper components for modern UI defined OUTSIDE to prevent re-mounting on each parent re-render
const FormGroup = ({ label, children, required, error, className = "col-6" }) => (
  <div className={`d-flex flex-column ${className}`} style={{ gap: "8px" }}>
    <div style={{ fontWeight: "500", fontSize: "13px", color: "#212129" }}>
      {label}
      {required && <span style={{ color: "red" }}> *</span>}
    </div>
    <div style={{ position: "relative" }}>
      {children}
      {error && (
        <span style={{ fontSize: "11px", fontWeight: 400, color: "#FF4444", marginTop: "4px", display: "block" }}>
          {error}
        </span>
      )}
    </div>
  </div>
);

const FormInput = ({ value, onChange, placeholder, type = "text", ...props }) => (
  <input
    type={type}
    value={value || ""}
    onChange={onChange}
    placeholder={placeholder}
    className="px-3"
    style={{
      width: "100%",
      height: "45px",
      borderRadius: "12px",
      border: "1px solid #E5E5E5",
      backgroundColor: "#FFFFFF",
      fontWeight: "500",
      fontSize: "14px",
      color: "#21272C",
      outline: "none",
      transition: "all 0.2s ease",
      ...props.style,
    }}
    {...props}
  />
);

const FormToggle = ({ label, checked, onChange }) => (
  <label
    className="d-flex align-items-center justify-content-between px-3 py-2"
    style={{
      cursor: "pointer",
      backgroundColor: "#FFFFFF",
      borderRadius: "10px",
      border: "0.8px solid #E5E5E5",
      minWidth: "140px",
      flex: "1",
    }}
  >
    <span style={{ fontSize: "13px", fontWeight: "600", color: "#4B5563" }}>{label}</span>
    <div
      style={{
        width: "36px",
        height: "20px",
        backgroundColor: checked ? "#6929E2" : "#E5E7EB",
        borderRadius: "20px",
        position: "relative",
        transition: "0.3s",
      }}
    >
      <div
        style={{
          width: "14px",
          height: "14px",
          backgroundColor: "#FFFFFF",
          borderRadius: "50%",
          position: "absolute",
          top: "3px",
          left: checked ? "19px" : "3px",
          transition: "0.3s",
        }}
      />
    </div>
    <input type="checkbox" checked={checked} onChange={onChange} style={{ display: "none" }} />
  </label>
);

const FormSelect = ({ value, onChange, options, ...props }) => (
  <select
    value={value || ""}
    onChange={onChange}
    className="px-3"
    style={{
      width: "100%",
      height: "45px",
      borderRadius: "12px",
      border: "1px solid #E5E5E5",
      backgroundColor: "#FFFFFF",
      fontWeight: "500",
      fontSize: "14px",
      color: "#21272C",
      outline: "none",
      cursor: "pointer",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.5 4.5L6 8L9.5 4.5' stroke='%238790A1' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 16px center",
      ...props.style,
    }}
    {...props}
  >
    {options.map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>
);

const Mailadd = ({ children }) => {

  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [chips, setChips] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [status, setStatus] = useState("active");
  const [reporterOption, setReporterOption] = useState(null);
  const [assigneeOption, setAssigneeOption] = useState(null);
  const [smtpServer, setSmtpServer] = useState("");
  const [smtpPort, setSmtpPort] = useState("");
  const [smtpType, setSmtpType] = useState("");
  const [startDate, setStartDate] = useState(new Date().toISOString().split("T")[0]);
  const [startTime, setStartTime] = useState(new Date().toTimeString().slice(0, 5));
  const [lastReadDate, setLastReadDate] = useState("");
  const [lastReadTime, setLastReadTime] = useState("");
  const [lastKey, setLastKey] = useState("");
  const [interval, setInterval] = useState("");
  const [roleOption, setRoleOption] = useState(null);
  const [locationOption, setLocationOption] = useState(null);
  const [selectedAssigneeList, setSelectedAssigneeList] = useState([]);
  const [mailContentOptions, setMailContentOptions] = useState({
    signature: false,
    attachments: false,
    contentImages: false,
    rm_dup_attach: false,
  });
  const [removedFilters, setRemovedFilters] = useState([]);
  const [clientId, setClientId] = useState("");
  const [tenantId, setTenantId] = useState("");
  const [clientSecret, setClientSecret] = useState("");

  const [validations, setValidations] = useState({
    email: "",
    password: "",
    status: "",
    reporter_id: "",
    assignee_id: "",
    server: "",
    port: "",
    type: "",
    start_date: "",
    start_time: "",
    interval: "",
    location_id: "",
    role_id: "",
    sender_autoassignees: "",
    last_read_date: "",
    last_read_time: "",
    client_id: "",
    tenant_id: "",
    client_secret: "",
  });

  useEffect(() => {
    if (id != null && id !== undefined) {
      emailConfigEdit(id);
    }
  }, [id]);
  const handleReporterChange = (selectedOptions) => {
    setReporterOption(selectedOptions);
  };
  const handleAssigneeChange = (selectedOptions) => {
    setAssigneeOption(selectedOptions);
  };
  const handleRoleChange = (selectedOptions) => {
    setRoleOption(selectedOptions);
  };
  const handleLocationChange = (selectedOptions) => {
    setLocationOption(selectedOptions);
  };
  const handleautoAssigneeDropdownChange = (selectedOptions) => {
    setSelectedAssigneeList(selectedOptions);
  };
  const handleMailContentOptionChange = (key) => {
    setMailContentOptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const [filters, setFilters] = useState([
    /* {
        "id": "",
            "subject": [],
            "subject_text":'',
            "email": [],
            "team": "1",
            "project": "1",
            "reporter": "1"
     } */
  ]); // Initial filter row

  const addFilter = () => {
    setFilters([
      ...filters,
      {
        id: "",
        subject: [],
        subject_text: "",
        email: [],
        team: { value: "", label: "Select" },
        project: { value: "", label: "Select" },
        component: { value: "", label: "Select" },
        status: "",
        assignee: [],
      },
    ]); // Add a new row
  };

  const removeFilter = (index) => {
    /*  setFilters(filters.filter((filter) => filter.id !== id)); */ // Remove the row by ID
    const filterToRemove = filters[index];
    if (filterToRemove && filterToRemove.id) {
      setRemovedFilters((prev) => [...prev, filterToRemove.id]);
    }
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleEmailDropdownChange = (selectedOptions, onChangeIndex) => {
    console.log("selectedOptions.........", selectedOptions);
    const tempList = [...filters];
    if (tempList[onChangeIndex] !== undefined) {
      tempList[onChangeIndex].email = selectedOptions;
      setFilters(tempList);
    }
  };

  const resetValidationState = () => ({
    email: "",
    password: "",
    status: "",
    reporter_id: "",
    assignee_id: "",
    server: "",
    port: "",
    type: "",
    start_date: "",
    start_time: "",
    interval: "",
    role_id: "",
    location_id: "",
    sender_autoassignees: "",
    last_read_date: "",
    last_read_time: "",
     client_id: "",
        tenant_id: "",
        client_secret: "",
  });

  const applyValidationErrors = (errorObj = {}) => {
    const validationTemp = resetValidationState();
    Object.entries(errorObj).forEach(([key, value]) => {
      validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
    });
    setValidations(validationTemp);
  };

  const fetchOptions = (inputValue, callback) => {
    setTimeout(() => {
      apiCall("get", "get_employee", null, {
        params: { term: inputValue || "" },
      })
        .then((response) => {
          const options = (response?.data?.suggestionlist ?? []).map((item) => ({
            value: String(item.email),
            label: String(item.email),
          }));
          callback(options);
        })
        .catch(() => callback([]));
    }, 1000);
  };

  const handleAssigneeDropdownChange = (selectedOptions, onChangeIndex) => {
    console.log("selectedOptions.........", selectedOptions);
    const tempList = [...filters];
    if (tempList[onChangeIndex] !== undefined) {
      tempList[onChangeIndex].assignee = selectedOptions;
      setFilters(tempList);
    }
  };

  const fetchOptionsAssignee = (fIndex, inputValue, callback) => {
    apiCall("get", "get_employee", null, {
      params: {
        team_id: filters[fIndex].team && filters[fIndex].team.value ? filters[fIndex].team.value : "",
        term: inputValue || "",
      },
    })
      .then((response) => {
        const options = (response?.data?.suggestionlist ?? []).map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options);
      })
      .catch(() => {
        callback([]);
      });
  };

  const fetchOptionsAutoAssignee = (inputValue, callback) => {
    apiCall("get", "get_employee", null, {
      params: { term: inputValue || "" },
    })
      .then((response) => {
        const options = (response?.data?.suggestionlist ?? []).map((item) => ({
          value: String(item.value),
          label: String(item.label),
        }));
        callback(options);
      })
      .catch(() => {
        callback([]);
      });
  };

  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "13px",
      color: "#212129",
      cursor: "pointer",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };
  const handleSubjectOnChange = (text, onChangeIndex) => {
    const tempList = [...filters];
    if (tempList[onChangeIndex] !== undefined) {
      console.log(text);
      tempList[onChangeIndex].subject_text = text;
      console.log(tempList[onChangeIndex].subject_text);
      setFilters(tempList);
    }
  };
  const handleSubjectKeyDown = (onChangeIndex) => {
    const tempList = [...filters];
    console.log(tempList[onChangeIndex].subject_text);
    if (tempList[onChangeIndex] !== undefined) {
      tempList[onChangeIndex].subject.push(tempList[onChangeIndex].subject_text);
      tempList[onChangeIndex].subject_text = "";
      setFilters(tempList);
    }
  };
  const removeChip = (listIndex, chipIndex) => {
    const tempList = [...filters];
    if (tempList[listIndex] !== undefined && tempList[listIndex].subject !== undefined) {
      console.log(listIndex, chipIndex);
      tempList[listIndex].subject = tempList[listIndex].subject.filter((_, i) => i !== chipIndex);
      setFilters(tempList);
    }
  };
  const handleProjectDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...filters];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].project = selectedOptions;
      setFilters(tempList);
    }
  };
  const handleComponentDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...filters];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].component = selectedOptions;
      setFilters(tempList);
    }
  };
  const handleStatusDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...filters];
    if (tempList[onChangeIndex] !== undefined) {
      tempList[onChangeIndex].status = selectedOptions;
      setFilters(tempList);
    }
  };
  const handleTeamDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...filters];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].team = selectedOptions;
      tempList[onChangeIndex.parentIndex].assignee = [];
      setFilters(tempList);
    }
  };

  /*       const handleReporterDropdownChange = (selectedOptions, onChangeIndex) => {
        const tempList =[...filters];
        if (tempList[onChangeIndex.parentIndex] !== undefined) {
            tempList[onChangeIndex.parentIndex].reporter=selectedOptions;
            setFilters(tempList);
        }
      } */
  const emailConfigSubmit = async () => {
    const tempEscalation = [];

    filters.forEach((item, index) => {
      tempEscalation.push({
        id: item.id,
        subject: item.subject,
        email: item.email.filter((item) => item.value !== "").map((item) => item.value),
        team_id: item.team.value ?? "",
        project_id: item.project.value ?? "",
        component_id: item.component.value ?? "",
        status: item.status ?? "",
        /* "reporter_id": item.reporter.value??'', */
        assignee_id: item.assignee.filter((item) => item.value !== "").map((item) => item.value),
      });
    });

    setValidations(resetValidationState());
      const requestBody = {
        email: email,
        password: password,
        status: status === "active" ? true : false,
        reporter_id: reporterOption != null ? reporterOption.value : "",
        assignee_id: assigneeOption != null ? assigneeOption.value : "",
        server: smtpServer,
        port: smtpPort,
        type: smtpType,
        start_date: startDate,
        start_time: startTime,
        interval: interval,
        filters: tempEscalation,
        removed_filters: removedFilters,
        role_id: roleOption != null ? roleOption.value : "",
        location_id: locationOption != null ? locationOption.value : "",
        signature: mailContentOptions.signature,
        attachments: mailContentOptions.attachments,
        content_images: mailContentOptions.contentImages,
        rm_dup_attach: mailContentOptions.rm_dup_attach,
        sender_autoassignees: selectedAssigneeList.filter((item) => item.value !== "").map((item) => item.value),
        last_read_date: lastReadDate,
        last_read_time: lastReadTime,
        client_id: clientId,
        tenant_id: tenantId,
        client_secret: clientSecret,
      };
      const isNew = id === null || id === undefined || id === -1;
      const response = await apiCall(
        isNew ? "post" : "put",
        isNew ? "email_config" : `email_config/${id}`,
        requestBody
      );

      if (response?.status === 200) {
        setSnackbarMessage(response.data?.message ?? "");
        setSnackbarStatus(response.data?.success ?? false);
        handleSnackbarShow();
        if (response.data?.success === true) {
          navigate(-1);
        }
        return;
      }

      if (response?.data?.error != null) {
        applyValidationErrors(response.data.error);
      }
  };
  const emailConfigEdit = async (id) => {
    const response = await apiCall("get", `email_config/${id}`);
    if (response?.status !== 200 || response.data?.success !== true) {
      return;
    }

    const config = response.data.config;
    setEmail(config.email);
    setStatus(config.status === true ? "active" : "inactive");
    setReporterOption({
      value: config.reporter_id ?? "",
      label: config.reporter ?? "Select",
    });
    setAssigneeOption({
      value: config.assignee_id ?? "",
      label: config.assignee ?? "Select",
    });
    setSmtpServer(config.smtp_server);
    setSmtpPort(config.smtp_port);
    setSmtpType(config.type ?? "");
    setStartDate(config.start_date);
    setStartTime(config.start_time);
    setLastReadDate(config.last_read_date ?? "");
    setLastReadTime(config.last_read_time ?? "");
    setInterval(config.reading_interval);

 setClientId(config.client_id ?? "");
            setTenantId(config.tenant_id ?? "");
            setClientSecret(config.client_secret ?? "");
    setRoleOption({
      value: config.role_id ?? "",
      label: config.role ?? "Select",
    });
    setLocationOption({
      value: config.location_id ?? "",
      label: config.location ?? "Select",
    });
    setMailContentOptions({
      signature: Boolean(config.signature ?? false),
      attachments: Boolean(config.attachments ?? false),
      contentImages: Boolean(config.content_images ?? false),
      rm_dup_attach: Boolean(config.rm_dup_attach ?? false),
    });
    setSelectedAssigneeList(
      (config.sender_autoassignees ?? []).map((item) => ({
        value: String(item.value),
        label: String(item.label),
      }))
    );
    const tempFilter = [];
    (config.filters ?? []).forEach((item) => {
      tempFilter.push({
        id: item.id,
        subject: item.subjects,
        subject_text: "",
        email: (item.emails ?? []).map((mail) => ({
          value: String(mail),
          label: String(mail),
        })),
        team: {
          value: item.team_id ?? "",
          label: item.team ?? "Select",
        },
        project: {
          value: item.project_id ?? "",
          label: item.project ?? "Select",
        },
        component: {
          value: item.component_id ?? "",
          label: item.component ?? "Select",
        },
        status: item.ticket_status,
        assignee: (item.assignees ?? []).map((assignee) => ({
          value: String(assignee.value),
          label: String(assignee.label),
        })),
      });
    });
    setFilters(tempFilter);
  };
  return (
    <Container fluid style={{ width: "100%", padding: "0px", fontFamily: "Satoshi" }}>
      <style>
        {`
          input[type="date"]::-webkit-calendar-picker-indicator,
          input[type="time"]::-webkit-calendar-picker-indicator {
            cursor: pointer;
          }
        `}
      </style>
      <div className="d-flex side4">
        <Row
          sm={10}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div className="maincontent3">
              <div className="px-3 d-flex flex-column" style={{ backgroundColor: "#F3F6F9", gap: "16px" }}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                    <Link to="/mail/list">
                      {" "}
                      <div>
                        <img src={backarrow} style={{ cursor: "pointer" }} alt="" />
                      </div>
                    </Link>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "16px",
                        color: "#212129",
                      }}
                    >
                      {id != null && id !== "" ? "Edit" : "Add"} Email
                    </div>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                    <Link to="/mail/list">
                      <button
                        className="px-4 py-2"
                        style={{
                          border: "0.6px solid #E5E5E5",
                          borderRadius: "100px",
                          backgroundColor: "#FFFFFF",
                          color: "#21272C",
                          fontWeight: "700",
                          fontSize: "14px",
                        }}
                      >
                        Cancel
                      </button>
                    </Link>

                    <button
                      onClick={() => emailConfigSubmit()}
                      className="px-4 py-2"
                      style={{
                        border: "0.6px solid #E5E5E5",
                        borderRadius: "100px",
                        backgroundColor: "#6929E2",
                        color: "#FFFFFF",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
                <div className="px-4 py-4" style={{ borderRadius: "16px", backgroundColor: "#FFFFFF", display: "flex", flexDirection: "column", gap: "32px" }}>
                  {/* Email Credentials */}
                  <div className="d-flex flex-column" style={{ gap: "20px" }}>
                    <div style={{ fontWeight: "700", fontSize: "18px", color: "#212129", borderLeft: "4px solid #6929E2", paddingLeft: "12px" }}>Email Credentials</div>
                    <div className="row g-3 align-items-start">
                      <FormGroup label="Email" required error={validations.email} className="col-md-5">
                        <FormInput value={email} onChange={(e) => setEmail(e.target.value)} placeholder="example@mail.com" />
                      </FormGroup>

                      <FormGroup label="Password" required error={validations.password} className="col-md-5">
                        <div style={{ position: "relative", width: "100%" }}>
                          <FormInput type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="******"/>
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: "absolute",
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              border: "none",
                              background: "none",
                              color: "#6929E2",
                              fontWeight: "700",
                              fontSize: "11px",
                              letterSpacing: "0.5px",
                              cursor: "pointer",
                              padding: "4px",
                              userSelect: "none",
                              zIndex: 2,
                            }}
                          >
                            {showPassword ? "HIDE" : "SHOW"}
                          </button>
                        </div>
                      </FormGroup>

                      <FormGroup label="Status" required error={validations.status} className="col-md-2">
                        <FormSelect
                          value={status}
                          onChange={(e) => setStatus(e.target.value)}
                          options={[
                            { value: "active", label: "🟢 Active" },
                            { value: "inactive", label: "🔴 Inactive" },
                          ]}
                        />
                      </FormGroup>
                    </div>

                    <div className="row g-3">
                      <FormGroup label="SMTP Server" required error={validations.server} className="col-md-5">
                        <FormInput value={smtpServer} onChange={(e) => setSmtpServer(e.target.value)} placeholder="smtp.gmail.com" />
                      </FormGroup>
                      <FormGroup label="SMTP Port" required error={validations.port} className="col-md-2">
                        <FormInput value={smtpPort} onChange={(e) => setSmtpPort(e.target.value)} placeholder="587" />
                      </FormGroup>
                      <FormGroup label="Auth Type" error={validations.type} className="col-md-5">
                        <FormSelect
                          value={smtpType}
                          onChange={(e) => setSmtpType(e.target.value)}
                          options={[
                            { value: "", label: "Select Type" },
                            { value: "imap", label: "IMAP" },
                            { value: "token", label: "Token-based (OAuth2)" },
                          ]}
                        />
                      </FormGroup>
                    </div>

                    {smtpType === "token" && (
                      <div className="row g-3 mx-1 mt-0" style={{ backgroundColor: "#F9F9FB", padding: "16px", borderRadius: "12px", border: "1px dashed #E5E5E5" }}>
                        <FormGroup label="Client ID" required error={validations.client_id} className="col-md-4">
                          <FormInput value={clientId} onChange={(e) => setClientId(e.target.value)} placeholder="Enter Client ID" />
                        </FormGroup>
                        <FormGroup label="Tenant ID" required error={validations.tenant_id} className="col-md-4">
                          <FormInput value={tenantId} onChange={(e) => setTenantId(e.target.value)} placeholder="Enter Tenant ID" />
                        </FormGroup>
                        <FormGroup label="Client Secret" required error={validations.client_secret} className="col-md-4">
                          <FormInput value={clientSecret} onChange={(e) => setClientSecret(e.target.value)} placeholder="Enter Client Secret" />
                        </FormGroup>
                      </div>
                    )}
                  </div>
                </div>

                {/*Execution & Features */}
                <div className="px-4 py-4" style={{ borderRadius: "16px", backgroundColor: "#FFFFFF" }}>
                  <div className="d-flex flex-column" style={{ gap: "20px" }}>
                    <div style={{ fontWeight: "700", fontSize: "18px", color: "#212129", borderLeft: "4px solid #6929E2", paddingLeft: "12px" }}>Execution & Features</div>
                    <div className="row g-4">
                      {/* Scheduling Card */}
                      <div className="col-md-6">
                        <div className="p-3" style={{ backgroundColor: "#F8F9FA", borderRadius: "12px", height: "100%" }}>
                          <div className="mb-3 d-flex align-items-center" style={{ gap: "8px" }}>
                            <div style={{ fontWeight: "600", fontSize: "14px", color: "#4B5563" }}>Scheduling</div>
                          </div>
                          <div className="row g-2">
                            <FormGroup label="Start Date" required error={validations.start_date} className="col-6">
                              <FormInput type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} onClick={(e) => e.target.showPicker()} />
                            </FormGroup>
                            <FormGroup label="Start Time" required error={validations.start_time} className="col-6">
                              <FormInput type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} onClick={(e) => e.target.showPicker()} />
                            </FormGroup>
                          </div>
                        </div>
                      </div>

                      {/* Last Read Card */}
                      <div className="col-md-6">
                        <div className="p-3" style={{ backgroundColor: "#F8F9FA", borderRadius: "12px", height: "100%" }}>
                          <div className="mb-3 d-flex align-items-center" style={{ gap: "8px" }}>
                            <div style={{ fontWeight: "600", fontSize: "14px", color: "#4B5563" }}>Last Read Pointer</div>
                          </div>
                          <div className="row g-2">
                            <FormGroup label="Last Read Date" error={validations.last_read_date} className="col-6">
                              <FormInput type="date" value={lastReadDate} onChange={(e) => setLastReadDate(e.target.value)} onClick={(e) => e.target.showPicker()} max={new Date().toISOString().split("T")[0]} />
                            </FormGroup>
                            <FormGroup label="Last Read Time" error={validations.last_read_time} className="col-6">
                              <FormInput type="time" value={lastReadTime} onChange={(e) => setLastReadTime(e.target.value)} onClick={(e) => e.target.showPicker()} />
                            </FormGroup>
                          </div>
                        </div>
                      </div>

                      {/* Content Features Card */}
                      <div className="col-12 mt-3">
                        <div className="p-3" style={{ backgroundColor: "#F8F9FA", borderRadius: "12px" }}>
                          <div className="d-flex flex-wrap gap-3">
                            {[
                              { key: "signature", label: "Read Signature" },
                              { key: "attachments", label: "Save Attachments" },
                              { key: "contentImages", label: "Inline Images" },
                              { key: "rm_dup_attach", label: "No Duplicate Attachments" },
                            ].map(({ key, label }) => (
                              <FormToggle key={key} label={label} checked={mailContentOptions[key]} onChange={() => handleMailContentOptionChange(key)} />
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/*Default Ticket Settings */}
                <div className="px-4 py-4" style={{ borderRadius: "16px", backgroundColor: "#FFFFFF" }}>
                  <div className="d-flex flex-column" style={{ gap: "20px" }}>
                    <div style={{ fontWeight: "700", fontSize: "18px", color: "#212129", borderLeft: "4px solid #6929E2", paddingLeft: "12px" }}>Default Ticket Settings</div>
                    <div className="row g-3">
                      <FormGroup label="Default Location" required error={validations.location_id} className="col-md-4">
                        <SearchWithAPI onDropdownChange={handleLocationChange} apiUrl={adminUrl + `get_location`} placeholder="Select Location" selectedValue={locationOption?.label || ""} selectedOption={locationOption} />
                      </FormGroup>
                      <FormGroup label="Default Role" required error={validations.role_id} className="col-md-4">
                        <SearchWithAPI onDropdownChange={handleRoleChange} apiUrl={adminUrl + `get_role`} placeholder="Select Role" selectedValue={roleOption?.label || ""} selectedOption={roleOption} />
                      </FormGroup>
                      <FormGroup label="Default Assignee" error={validations.assignee_id} className="col-md-4">
                        <SearchWithAPI onDropdownChange={handleAssigneeChange} apiUrl={apiUrl + `get_employee`} placeholder="Select Assignee" selectedValue={assigneeOption?.label || ""} selectedOption={assigneeOption} />
                      </FormGroup>
                    </div>
                    <div className="row g-3">
                      <FormGroup label="Sender Auto Assignees" className="col-12">
                        <AsyncSelect isMulti cacheOptions value={selectedAssigneeList} loadOptions={fetchOptionsAutoAssignee} onChange={handleautoAssigneeDropdownChange} defaultOptions placeholder="Search Employees..." styles={multiselectCustomStyles} />
                      </FormGroup>
                    </div>
                  </div>
                </div>
                {/*Smart Routing Filters */}
                <div className="px-4 py-4" style={{ borderRadius: "16px", backgroundColor: "#FFFFFF" }}>
                  <div className="d-flex flex-column" style={{ gap: "20px" }}>
                    <div style={{ fontWeight: "700", fontSize: "18px", color: "#212129", borderLeft: "4px solid #6929E2", paddingLeft: "12px" }}>Smart Routing Filters</div>

                    {filters.map((filter, fIndex) => (
                      <div
                        key={"line" + filter.id}
                        className="px-3 py-3"
                        style={{ backgroundColor: "#F8F9FA", borderRadius: "12px", position: "relative" }}
                      >
                        {/* Delete button */}
                        <div
                          onClick={() => removeFilter(fIndex)}
                          style={{
                            position: "absolute",
                            right: "12px",
                            top: "12px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #E5E5E5",
                          }}
                        >
                          <img src={reddelete} style={{ width: "36px", height: "36px" }} alt="Delete" />
                        </div>

                        {/* Row 1: Email, Subject, Project */}
                        <Row className="g-3 pe-5">
                          <Col sm={12} md={6} lg={4} className="text-start">
                            <p style={{ fontSize: "13px", fontWeight: "500", color: "#212129", marginBottom: "8px" }}>Email</p>
                            <AsyncSelect
                              isMulti
                              cacheOptions
                              value={filter.email}
                              loadOptions={fetchOptions}
                              onChange={(selectedOptions) => handleEmailDropdownChange(selectedOptions, fIndex)}
                              defaultOptions
                              placeholder="Search email..."
                              styles={multiselectCustomStyles}
                              isClearable={false}
                            />
                          </Col>
                          <Col sm={12} md={6} lg={4} className="text-start">
                            <p style={{ fontSize: "13px", fontWeight: "500", color: "#212129", marginBottom: "8px" }}>Subject</p>
                            <div
                              style={{
                                border: "1px solid #E5E5E5",
                                borderRadius: "12px",
                                padding: "6px",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "6px",
                                backgroundColor: "#FFFFFF",
                                width: "100%",
                                minHeight: "40px",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", alignItems: "center", width: "100%" }}>
                                {filter.subject.map((chip, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      borderRadius: "8px",
                                      gap: "8px",
                                      backgroundColor: "#F1F5F9",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      padding: "4px 8px",
                                    }}
                                  >
                                    <span style={{ fontWeight: "500", fontSize: "12px", color: "#212129" }}>{chip}</span>
                                    <img src={close} style={{ width: "16px", height: "16px", cursor: "pointer" }} onClick={() => removeChip(fIndex, index)} alt="Remove" />
                                  </div>
                                ))}
                                <input
                                  type="text"
                                  placeholder="Type & press enter..."
                                  value={filter.subject_text}
                                  onChange={(e) => handleSubjectOnChange(e.target.value, fIndex)}
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                      event.preventDefault();
                                      handleSubjectKeyDown(fIndex);
                                    }
                                  }}
                                  style={{
                                    border: "none",
                                    outline: "none",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    color: "#212129",
                                    flex: "1",
                                    minWidth: "120px",
                                    minHeight: "36px",
                                  }}
                                  className="px-2"
                                />
                              </div>
                            </div>
                          </Col>
                          <Col sm={12} md={6} lg={4} className="text-start">
                            <p style={{ fontSize: "13px", fontWeight: "500", color: "#212129", marginBottom: "8px" }}>Project</p>
                            <SearchWithAPI searchId={fIndex} onChangeIndex={{ parentIndex: fIndex }} onDropdownChange={handleProjectDropdownChange} apiUrl={apiUrl + `get_project`} placeholder={"Project"} selectedValue={filter.project != null ? filter.project.label : ""} selectedOption={filter.project} />
                          </Col>
                        </Row>

                        {/* Row 2: Team, Status, Assignee */}
                        <Row className="g-3 mt-1 pe-5">
                          <Col sm={12} md={6} lg={3} className="text-start">
                            <p style={{ fontSize: "13px", fontWeight: "500", color: "#212129", marginBottom: "8px" }}>Team</p>
                            <SearchWithAPI searchId={fIndex} onChangeIndex={{ parentIndex: fIndex }} onDropdownChange={handleTeamDropdownChange} apiUrl={apiUrl + `get_team`} placeholder={"Team"} selectedValue={filter.team != null ? filter.team.label : ""} selectedOption={filter.team} />
                          </Col>
                          <Col sm={12} md={6} lg={3} className="text-start">
                            <p style={{ fontSize: "13px", fontWeight: "500", color: "#212129", marginBottom: "8px" }}>Status</p>
                            <select
                              className="w-100 px-3"
                              style={{
                                height: "45px",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#21272C",
                                border: "1px solid #E5E5E5",
                                backgroundColor: "#FFFFFF",
                                borderRadius: "12px",
                                outline: "none",
                              }}
                              value={filter.status != null ? filter.status : ""}
                              onChange={(e) => handleStatusDropdownChange(e.target.value, fIndex)}
                            >
                              <option value="">Select</option>
                              <option value="Open">Open</option>
                              <option value="In Progress">In Progress</option>
                              <option value="Hold">Hold</option>
                              <option value="Closed">Closed</option>
                            </select>
                          </Col>
                          <Col sm={12} md={6} lg={6} className="text-start">
                            <p style={{ fontSize: "13px", fontWeight: "500", color: "#212129", marginBottom: "8px" }}>Assignee</p>
                            <AsyncSelect
                              isMulti
                              value={filter.assignee}
                              loadOptions={(inputValue, callback) => fetchOptionsAssignee(fIndex, inputValue, callback)}
                              onChange={(selectedOptions) => handleAssigneeDropdownChange(selectedOptions, fIndex)}
                              placeholder="Search assignee..."
                              styles={multiselectCustomStyles}
                              isClearable={false}
                            />
                          </Col>
                        </Row>
                      </div>
                    ))}

                    <div className="d-flex align-items-center" style={{ gap: "16px" }}>
                      <button
                        onClick={addFilter}
                        style={{
                          borderRadius: "100px",
                          fontWeight: "700",
                          fontSize: "13px",
                          color: "#6929E2",
                          border: "1.5px dashed #6929E2",
                          cursor: "pointer",
                          padding: "8px 20px",
                          backgroundColor: "transparent",
                        }}
                      >
                        + Add Filter
                      </button>
                    </div>

                    {filters.length === 0 && (
                      <div className="p-4 text-center" style={{ color: "#9CA3AF", fontStyle: "italic", fontSize: "14px" }}>
                        No filter rules defined. Emails will use defaults.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <ToastContainer position="top-end" style={{ padding: "20px" }}>
        <Toast bg={snackbarStatus ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide style={{ borderRadius: "12px" }}>
          <Toast.Body style={{ color: "white", fontWeight: "600" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default Mailadd;
